/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  call, put,
} from 'redux-saga/effects';
import {
  requestGenerateOTP, requestGetUserDetails, requestVerifyOTP, requestResendOtpMobile, requestSetPreviousStep,
} from './accountRequests';
import {
  logout,
  setAccountError,
  setAccountStatus,
  setAuthCredentials,
  setGenerateOTPInfo,
  setUserDetails,
  setVerifiedTokenAndUserDetails,
  setPreviousStep,
  setOtpVerified,
  resendOtpFailure,
  resendOtpSuccess,
} from './accountSlice';
import { clearData, saveData } from '../../utils/localStorage';

export type SetGenerateOTPInfo = {
  type: typeof setGenerateOTPInfo.type;
  payload: any;
};

export function* handleGenerateOTP(action:any): Generator<any, any, any> {
  yield put(setAccountStatus('loading'));
  try {
    const response: any = yield call(requestGenerateOTP, { phone: action.payload.mobileNumber }, 'login');
    const { data } = response;
    yield put(setGenerateOTPInfo({ mobileNumber: action.payload.mobileNumber, verifyToken: data.token }));
  } catch (error:any) {
    if (error?.response?.data?.message === 'mobile number not registered') {
      try {
        const response: any = yield call(requestGenerateOTP, { phone: action.payload.mobileNumber }, 'signup');
        const { data } = response;

        yield put(setGenerateOTPInfo({ mobileNumber: action.payload.mobileNumber, verifyToken: data.token }));
      } catch (err: any) {
        yield put(setAccountError({ isError: true, message: err?.response?.data?.message }));
      }
    } else if (error?.response?.data?.errorMessage === 'request too early') {
      yield put(setAccountError({ isError: true, message: 'Please wait for some time before requesting again' }));
    } else {
      yield put(setAccountError({ isError: true, message: error?.response?.data?.message || '' }));
    }
  }
}

export function* handleVerifyOTP(action:any): Generator<any, any, any> {
  yield put(setAccountStatus('loading'));
  try {
    const response = yield call(
      requestVerifyOTP,
      { otp: action.payload.otp, phone: action.payload.mobileNumber },
      { 'x-access-token': action.payload.verifyToken }
    );
    const { data } = response;
    if (response.status === 200) {
      yield put(setUserDetails(data.user));
      yield put(setOtpVerified(true));
    }
    yield call(saveData, 'authorization', { mobileNumber: action.payload.mobileNumber, authToken: data.token });
    yield put(setAuthCredentials({ mobileNumber: action.payload.mobileNumber, authToken: data.token }));
  } catch (error: any) {
    yield put(setOtpVerified(false));
    if (error?.response?.data?.message === 'max attempts reached') {
      yield put(setAccountError({
        isError: true,
        message: 'OTP has expired. Please request for a new OTP',
      }));
    } else {
      yield put(setAccountError({ isError: true, message: error?.response?.data?.message || '' }));
    }
  }
}

export function* handleGetUserDetails(): Generator<any, any, any> {
  yield put(setAccountStatus('loading'));
  try {
    const response = yield call(
      requestGetUserDetails
    );
    const { data } = response;
    yield put(setUserDetails(data.user));
  } catch (error: any) {
    yield put(logout());
  }
}

export function* handleVerifyPrevTokenAndGetUserDetails(action:any): Generator<any, any, any> {
  yield put(setAccountStatus('loading'));
  try {
    const response = yield call(
      requestGetUserDetails
    );
    const { data } = response;
    yield put(setVerifiedTokenAndUserDetails({ ...action.payload, userDetails: data.user }));
  } catch (error: any) {
    clearData();
    yield put(logout());
  }
}

export function* handleResendOtpMobile(action:any): Generator<any, any, any> {
  yield put(setAccountStatus('loading'));
  try {
    const response = yield call(
      requestResendOtpMobile,
      { phone: action.payload.mobileNumber },
      { 'x-access-token': action.payload.verifyToken }
    );
    const { data } = response;
    yield put(resendOtpSuccess(true));
  } catch (error: any) {
    yield put(resendOtpFailure(false));
    yield put(setAccountError({ isError: true, message: error?.response?.data?.message || '' }));
  }
}

export function* handleSetPreviousStep(action:any): Generator<any, any, any> {
  try {
    const response = yield call(
      requestSetPreviousStep,
      { },
      { 'x-access-token': action.payload.authToken }
    );
    const { data } = response;
    if (response.status === 200) {
      yield put(setPreviousStep(data.user.currentStep));
    }
  } catch (error: any) {
    yield put(setPreviousStep(undefined));
  }
}
